/*common*/
require('./common');

/*custom css files*/
require('../scss/pages/single/layout.scss');
require('../js/lib/lightgallery/dist/css/lightgallery.css');

/*custom js files*/
require('../js/lib/lightgallery/dist/js/lightgallery-all');
require('../js/pages/single');
require('../js/partials/content');
require('../js/partials/parallax');


// WEBPACK FOOTER //
// ./src/single.js